import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { CreativeRatingChart } from './CreativeRatingChart';
import { ConversionRateChart } from './ConversionRateChart';
export const ChartSection = () => {
    return (_jsxs(Stack, { gap: "26px", width: "100%", flexWrap: "wrap", direction: "row", marginTop: "16px", children: [_jsx(CreativeRatingChart, {}), _jsx(ConversionRateChart, {})] }));
};
